import React from 'react'
import { Model } from 'survey-core'
import { Survey } from 'survey-react-ui'
// import 'survey-core/defaultV2.min.css'
import { templateJson } from './json/templateJson'

// import { useNavigate } from 'react-router-dom'

const IsSubmitted = () => {
  let mySubmittedJson = {
    ...templateJson,
    completeText: '完成',
    completedHtml: `<h3>感謝您的參與</h3><h4 style='margin-top:50px'>手機下載 EZChoice</h4><h6 style='margin:20px'><a href='https://apps.apple.com/tw/app/ezchoice-%E6%98%93%E6%8F%AA%E7%B6%B2/id1458573198'>Apple Store 下載連結</a></h6><h6 style='margin:20px'><a href='https://play.google.com/store/apps/details?id=com.dataa.newezchoice'>Google Play 商店下載連結</a></h6><h4 style='margin-top:50px'>填寫其他問卷</h4><h5><a href=${window.location.origin}>回到首頁</a></h5>更多即時好康資訊！<br />立即加入EZChoice Line@好友</h4><h5><a href='https://lin.ee/HWETcqy'>EZChoice LINE@</a></h5>`,
    pages: [
      {
        name: 'page0',
        elements: [
          {
            type: 'panel',
            elements: [
              {
                type: 'html',
                name: 'intro',
                html: "<h2 style='text-align: center'>您已填過此問卷</h2>",
              },
            ],
            name: 'panel1',
          },
        ],
      },
    ],
  }
  const survey = new Model(mySubmittedJson)

  return <Survey model={survey} />
}

export default IsSubmitted
